import React from "react";
import logo from "../../images/Snowieslogo.png";
import { Bg, Heading, Logoimg, HeadingDiv } from "./HeroElements";

function HeroSection() {
  return (
    <>
      <Bg>
          <Logoimg alt="loading" src={logo} />
          <HeadingDiv>
            <Heading>Trippy Chicks Club</Heading>
          </HeadingDiv>
      </Bg>
    </>
  );
}

export default HeroSection;
